import {
    NavLink
  } from "react-router-dom";
import {IconHome ,IconBandage , IconUsers , IconFriends, IconCalendarTime, IconBuildingWarehouse, IconBoxMultiple3, IconPackages, IconBuildingCommunity, IconActivity, IconVideo } from '@tabler/icons-react';
import { useEffect,useState,useCallback } from "react";

const Footer = () => {
    const mhsnav = [
        {
            name:'Home',
            link:'dashboard',
            icon:<IconHome size={25}/>
        },
        {
            name:'Place Order',
            link:'form',
            icon:<IconCalendarTime size={25}/>
        },
        {
            name:'Products',
            link:'products',
            icon:<IconPackages size={25}/>
        },
        {
            name:'Communication',
            link:'communication',
            icon:<IconVideo size={25}/>
        }
    ]

    return (
         (
            <div className={`flex justify-around fixed bottom-0 w-full shadow-md py-1 pt-3 text-mhs-secondary text-xs !z-10`} style={{background: 'linear-gradient(180deg, #FFF5E1 0%, #FDE7B7 60%)'}}>
                {mhsnav.map((navDetails) => (
                    
                    <NavLink
                        key={navDetails.link}
                        className={({ isActive }) =>
                            isActive ? 'nav-btn active' : 'nav-btn'
                        }
                        to={navDetails.link}
                    >
                        <div className="flex flex-col justify-center items-center">
                            <span className="nav-icon font-extrabold !text-xl">{navDetails.icon}</span>
                            <span>{navDetails.name}</span>
                        </div>
                    </NavLink>
                ))}
            </div>
        )
    );
};

export default Footer;
